import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Check } from "lucide-react";

const ELIGIBLE = [
  "A genuine person requesting an exterior-cleaning service",
  "Located within the agreed service territory",
  "Requesting a service included in the campaign",
  "Providing usable contact information",
  "Generated exclusively for the client",
];

const Guarantee = () => {
  return (
    <section
      id="guarantee"
      className="scroll-mt-20 bg-gradient-to-b from-emerald-50/40 via-white to-white py-14 sm:py-20"
    >
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
        <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-emerald-100 px-3.5 py-1.5 text-xs font-black uppercase tracking-widest text-emerald-800 ring-1 ring-emerald-200/70">
          <ShieldCheck className="h-3.5 w-3.5" /> The Guarantee
        </p>
        <h2 className="text-3xl font-black uppercase leading-[1.05] tracking-tight text-brand-black sm:text-4xl lg:text-5xl">
          30 Exclusive Local Enquiries In 30 Days —{" "}
          <span className="text-emerald-600">Or We Work For Free.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-grayMid sm:text-base">
          We will build, launch and manage your exterior-cleaning campaigns. If your campaign does not generate 30
          eligible local enquiries during its first 30 days live, we will continue managing it without charging our
          weekly management fee until it does.
        </p>
        <p className="mt-3 text-xs font-black uppercase tracking-widest text-brand-grayMid">
          No Setup Fee · No Lock-In Contract · One Operator Per Agreed Territory
        </p>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-white p-6 text-left shadow-sm ring-1 ring-emerald-100 sm:p-8">
          <p className="text-xs font-black uppercase tracking-widest text-emerald-700">
            An eligible enquiry is:
          </p>
          <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {ELIGIBLE.map((line) => (
              <li
                key={line}
                className="flex items-start gap-2.5 text-sm leading-snug text-brand-black"
              >
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 ring-1 ring-emerald-200">
                  <Check className="h-3 w-3 text-emerald-700" />
                </span>
                {line}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/offer"
            className="inline-flex min-h-[56px] items-center justify-center gap-2 rounded-2xl bg-brand-blue px-7 py-4 text-sm font-black uppercase tracking-wider text-white shadow-xl shadow-blue-200/60 ring-1 ring-blue-700/10 transition-all hover:bg-blue-600 active:scale-[0.99]"
          >
            Check If My Territory Is Available <ArrowRight className="h-5 w-5" />
          </Link>
          <a
            href="#results"
            className="inline-flex min-h-[56px] items-center justify-center rounded-2xl border-2 border-gray-200 bg-white px-6 py-4 text-sm font-black uppercase tracking-wider text-brand-black transition-all hover:border-brand-blue/40 hover:bg-blue-50/60"
          >
            See Client Results
          </a>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
